/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Directory_Detail_Signals_SubtitleInputs */

const en_directory_detail_signals_subtitle = /** @type {(inputs: Directory_Detail_Signals_SubtitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`How ${i?.name} scores on agent readiness and AI visibility`)
};

const zh_directory_detail_signals_subtitle = /** @type {(inputs: Directory_Detail_Signals_SubtitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} 在 Agent 就绪度与 AI 可见性上的得分`)
};

/**
* | output |
* | --- |
* | "How {name} scores on agent readiness and AI visibility" |
*
* @param {Directory_Detail_Signals_SubtitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_detail_signals_subtitle = /** @type {((inputs: Directory_Detail_Signals_SubtitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Detail_Signals_SubtitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_detail_signals_subtitle(inputs)
	return zh_directory_detail_signals_subtitle(inputs)
});
export { directory_detail_signals_subtitle as "directory.detail.signals.subtitle" }